<template>
  <div>
    <div class="header">
      <a :href="logoLink">
        <img
          :src="
            siteType.GetSiteType() == siteType.SITE_TYPE_NUTS
              ? '/static/img/register/logo.svg'
              : '/static/img/register/KKBrand_Logo.png'
          "
        />
      </a>
    </div>
    <div>
      <div class="container">
        <div class="detail_section">
          <div class="detail_title">
            <p>{{ tips }}</p>
          </div>
          <div class="email_icon">
            <img
              :src="
                siteType.GetSiteType() == siteType.SITE_TYPE_NUTS
                  ? '/static/img/register/email/status/email_unverified_nuts.png'
                  : '/static/img/register/email/status/email_unverified.png'
              "
            />
          </div>
          <div class="detail_content">
            <div class="description">
              <p>
                <!-- {{ $t(description) }} -->
                {{ $t("register.LAB_EMAIL_EXPIRED_2") }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import siteType from "../../configs/siteType";
import { logoLinkMixin } from '../../mixin/logoLink'

export default {
  mixins: [logoLinkMixin],
  data() {
    return {
      status: Number(this.$route.query.status),
      tips: "",
      description: "",
      content: {
        expired: "register.LAB_EMAIL_EXPIRED_1",
        mitid_exist: "register.LAB_MITID_ALREADYLINKED_TIP",
        mitid_fail: "register.LAB_MITID_CPR_STATUS_ERROR",
        failed: "register.LAB_EMAIL_FAILED",
        // description: {
        //   expired:'register.LAB_EMAIL_EXPIRED_2',
        //   failed:'register.LAB_EMAIL_EXPIRED_2',
        //   mitid_fail:'register.LAB_EMAIL_EXPIRED_2',
        //   mitid_exist:'register.LAB_EMAIL_EXPIRED_2',
        // }
      },
      siteType,
    };
  },
  created() {
    /**
     *  code 错误码
     *  REGISTER_USERNAME_ERROR             = -3
        REGISTER_INVITE_CODE_ERROR          = -5
        REGISTER_FORBID_PLATFORM_ERROR      = -8
        REGISTER_PLATFORM_ERROR_NEED_GPS    = -9
        REGISTER_EMAIL_DOMAIN_BAN           = -14
        REGISTER_ILLEAGE_REQUEST            = -15
        REGISTER_EMAIL_VERIFY_DONE          = -16
        REGISTER_EMAIL_VERIFY_EXPIRED       = -17
        REGISTER_MITID_NEED_VERIFY          = -18 // MitidVerificationStatus_DEFAULT
        REGISTER_MITID_VERIFICATION_PENDING = -19 // MitidVerificationStatus_PENDING
        REGISTER_MITID_FAIL_ERROR           = -20 // Mitid VERIFY FAILED
        REGISTER_MITID_EXISTED              = -21

        
        中转页面对code进行了处理，所以此页面拿到的code需要去掉负号
     */
    let statusLangKey = "";

    if (this.status === -17) {
      statusLangKey = "expired";
      this.tips = this.$t(this.content[statusLangKey]);
    } else {
      if (this.status === -20) {
        statusLangKey = "mitid_fail";
        this.tips = this.$t(this.content[statusLangKey], {code: this.$route.query.cpr_code});
      } else if (this.status === -21) {
        statusLangKey = "mitid_exist";
        this.tips = this.$t(this.content[statusLangKey], {email: this.$route.query.registered_email});
      } else {
        statusLangKey = "failed";
        this.tips = this.$t(this.content[statusLangKey]);
      }
    }

    // this.description = this.content['description'][statusLangKey]
  },
};
</script>
<style lang="less">
body,
#default-layout {
  background-color: #151515;
  height: 100%;
}
html,
body,
#default-layout {
  height: 100%;
}
</style>
<style lang="less" scoped>
.header {
  height: 70px;
  background-color: #000000;
  img {
    position: absolute;
    left: 50px;
    top: 15px;
    width: 170px;
    height: auto;
  }
}
.container {
  max-width: 1440px;
  height: 100%;
  margin: 0 auto;
  position: relative;
  .detail_section {
    margin-top: 250px;
    .detail_title {
      p {
        font-size: 24px;
        color: #ffffff;
        text-align: center;
        margin-top: 130px;
        line-height: 40px;
        white-space: pre-line;
      }
    }
    .email_icon {
      text-align: center;
      img {
        width: 100%;
        height: 400px;
        max-width: 400px;
        margin-top: 32px;
      }
    }
    .detail_content {
      margin: 0 50px;
      .description {
        p {
          font-size: 24px;
          color: #ffffff;
          text-align: center;
          margin: 32px 50px 0 50px;
        }
      }
    }
  }
}
</style>
